import React from 'react';

import ProfileImage from '@buyside/components/presentation/ProfileImage/profileImage';
import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from '@buyside/components/presentation/Skeleton/skeleton';

import { defaultUserImageUrl } from '@buyside/util/urlHelper';

import styles from './membersIndexCardStyles.scss';

const MembersIndexCardLoading: React.FC = () => {
  return (
    <div className={styles.membersIndexCard}>
      <ProfileImage className={styles.profileImage} size="small" source={defaultUserImageUrl()} />
      <div className={styles.mainContentContainer}>
        <div className={styles.userInformationContainer}>
          <div>
            <p>
              <Skeleton width={SKELETON_WIDTHS.MEDIUM} />
            </p>
            <p>
              <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
            </p>
          </div>
          <p>
            <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
          </p>
        </div>
        <p>
          <Skeleton width={SKELETON_WIDTHS.FULL} />
          <Skeleton width={SKELETON_WIDTHS.TWO_THIRD} />
        </p>
      </div>
    </div>
  );
};

export default MembersIndexCardLoading;
